var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"select-tFont",staticStyle:{"text-align":"center"}},[_vm._v(" "+_vm._s(_vm.showPrice.showNameLabel ? _vm.showPrice.showNameLabel : _vm.showPrice.showTime)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }